export const getExtraItems = saleListing => {
  if (saleListing.uniqueSaleProduct) {
    const { uniqueSaleProduct: { items: typicallyIncludedItems }, items: includedItems } = saleListing
    const typicallyIncludedItemsIds = typicallyIncludedItems.map(item => item.id)

    return includedItems.filter(item => !typicallyIncludedItemsIds.includes(item.id))
  } else {
    return []
  }
}

export const getMissingItems = saleListing => {
  if (saleListing.uniqueSaleProduct) {
    const { uniqueSaleProduct: { items: typicallyIncludedItems }, items: includedItems } = saleListing
    const includedItemIds = includedItems.map(item => item.id)

    return typicallyIncludedItems.filter(item => !includedItemIds.includes(item.id))
  } else {
    return []
  }
}
